
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavbarComponent } from './navbar/navbar.component';
import { I18NModule } from 'api-angular-monitorias-intl';
import { FooterComponent } from './footer/footer.component';
import { NgxBootstrapModule } from '../ngx-bootstrap.module';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        I18NModule,
        NgxBootstrapModule
    ],
    declarations: [NavbarComponent, FooterComponent],
    exports: [CommonModule, FormsModule, ReactiveFormsModule,NavbarComponent, FooterComponent,I18NModule, NgxBootstrapModule],
    providers: []
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts